<template>
  <v-row>
    <v-col cols="12">
      <BaseBlock v-if="titreAtelier" :title="titreAtelier">
        <v-form v-model="valid" ref="form">
          <BaseAlert :error="error" />
          <v-row>
            <v-col cols="12" md="4" offset="0" offset-md="1">
              <v-select
                v-if="listeCampus.length > 1"
                v-model="atelier.campus"
                :items="listeCampus"
                :readonly="isAtelierEchu(atelier)"
                :filled="isAtelierEchu(atelier)"
                hint="Campus"
                item-text="libelle"
                item-value="id"
                label="Campus *"
                persistent-hint
                return-object
                single-line
                :rules="campusRules"
                @input="resetApiErrors('campus')"
                :error-messages="checkApiErrors('campus')"
              ></v-select>
              <v-text-field
                v-else
                v-model="atelier.campus.libelle"
                label="Campus *"
                dense
                filled
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4" offset="0" offset-md="2">
              <v-select
                v-model="atelier.animateur"
                :items="listeAnimateurs"
                :readonly="isAtelierEchu(atelier)"
                :filled="isAtelierEchu(atelier)"
                hint="Animateur"
                :item-text="nomPrenomAnimateur"
                item-value="id"
                label="Animateur *"
                persistent-hint
                return-object
                single-line
                :rules="animateurRules"
                @input="resetApiErrors('animateur')"
                :error-messages="checkApiErrors('animateur')"
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="3" offset="0" offset-md="1">
              <v-menu
                v-model="showCalendar"
                :disabled="isAtelierEchu(atelier)"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                max-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="formatedDate"
                    label="Date de début *"
                    prepend-icon="event"
                    readonly
                    :filled="isAtelierEchu(atelier)"
                    :clearable="!isAtelierEchu(atelier)"
                    v-on="on"
                    :rules="dateDebutRules"
                  ></v-text-field>
                </template>
                <v-date-picker
                  locale="fr-fr"
                  :min="minDateDebut"
                  :max="maxDateDebut"
                  v-model="dateDebut"
                  @input="showCalendar = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="3">
              <v-menu
                v-model="showTimer"
                :disabled="isAtelierEchu(atelier)"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                max-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="heureDebut"
                    label="Heure de début *"
                    prepend-icon="mdi-clock-time-four-outline"
                    readonly
                    :filled="isAtelierEchu(atelier)"
                    :clearable="!isAtelierEchu(atelier)"
                    v-on="on"
                    :rules="heureDebutRules"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-model="heureDebut"
                  format="24hr"
                  @click:minute="showTimer = false"
                ></v-time-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="1" offset="0" offset-md="1">
              <v-checkbox
                v-model="atelier.ouvert"
                label="Ouvert"
                :readonly="isAtelierEchu(atelier)"
                :filled="isAtelierEchu(atelier)"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="2" offset="0" offset-md="1">
              <v-text-field
                v-model="atelier.nbPlaces"
                label="Nombre de places *"
                :readonly="isAtelierEchu(atelier)"
                :filled="isAtelierEchu(atelier)"
                dense
                @input="resetApiErrors('nbPlaces')"
                :error-messages="checkApiErrors('nbPlaces')"
                :rules="nbPlacesRules"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="8" offset="0" offset-md="1">
              <v-textarea
                v-model="atelier.lieu"
                label="Lieu *"
                :readonly="isAtelierEchu(atelier)"
                :filled="isAtelierEchu(atelier)"
                outlined
                auto-grow
                hide-details="true"
                dense
                @input="resetApiErrors('lieu')"
                :error-messages="checkApiErrors('lieu')"
                :rules="lieuRules"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6" offset="0" offset-md="3">
              <div class="text-center">
                <v-btn
                  v-if="!isAtelierEchu(atelier)"
                  class="mx-2"
                  :disabled="!valid"
                  color="primary"
                  @click="enregistrer"
                  :loading="loadingAtelier"
                >
                  <v-icon left>save</v-icon>Enregistrer
                </v-btn>
                <router-link
                  :to="{
                    name: 'gestion-ateliers',
                  }"
                  tag="v-btn"
                >
                  <v-icon title="Retour"></v-icon>
                  Retour</router-link
                >
              </div>
            </v-col>
          </v-row>
        </v-form>
      </BaseBlock>
    </v-col>
  </v-row>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";
import BaseForm from "@/components/base/BaseForm";
import ApiAtelierRepository from "@/repositories/ApiAtelierRepository";
import ApiCampusRepository from "@/repositories/ApiCampusRepository";
import ApiReferentRepository from "@/repositories/ApiReferentRepository";
import moment from "moment";
import BaseAlert from "@/components/base/BaseAlert";

export default {
  name: "FormAtelier",
  components: { BaseBlock, BaseAlert },
  extends: BaseForm,
  props: ["idAtelier"],

  data() {
    return {
      atelier: {
        id: null,
        dateDebut: "",
        nbPlaces: "",
        ouvert: false,
        campus: {},
        lieu: "",
        animateur: {
          id: null,
        },
      },
      campusRules: [
        (v) => (!!v && !!v.id && !!v.id > 0) || "Le campus est requis",
      ],
      animateurRules: [
        (v) => (!!v && !!v.id && !!v.id > 0) || "L'animateur est requis",
      ],
      dateDebutRules: [(v) => !!v || "La date de début doit être renseignée"],
      heureDebutRules: [(v) => !!v || "L'heure de début doit être renseignée"],
      lieuRules: [(v) => !!v || "Le lieu est requis"],
      nbPlacesRules: [
        (v) => !!v || "Le nombre de places est requis",
        (v) =>
          /^[1-9][0-9]*$/.test(v) || "Le nombre de places n'est pas valide",
      ],
      loadingAtelier: false,
      listeCampus: [],
      showCalendar: false,
      listeAnimateurs: [],
      dateDebut: "",
      heureDebut: "",
      showTimer: false,
    };
  },
  computed: {
    titreAtelier() {
      return this.idAtelier > 0
        ? this.isAtelierEchu(this.atelier)
          ? "Visualisation de l'atelier id=" + this.idAtelier
          : "Édition de l'atelier id=" + this.idAtelier
        : "Nouvel atelier";
    },
    formatedDate: {
      get() {
        return this.dateDebut
          ? moment(this.dateDebut).format("DD/MM/YYYY")
          : "";
      },
      set(value) {
        this.dateDebut = value;
      },
    },
    minDateDebut() {
      return moment().format("YYYY-MM-DD");
    },
    maxDateDebut() {
      return moment().format("MM") > 8
        ? moment([moment().add(1, "years").format("YYYY"), 7, 31]).format(
            "YYYY-MM-DD"
          )
        : moment([moment().format("YYYY"), 7, 31]).format("YYYY-MM-DD");
    },
  },
  async created() {
    this.getListeCampus();
    this.getListeAnimateurs();
    if (this.idAtelier > 0) {
      await this.getAtelier(this.idAtelier);
    }
  },
  methods: {
    nomPrenomAnimateur(animateur) {
      return animateur.nom + " " + animateur.prenom;
    },
    async getAtelier(id) {
      try {
        const atelier = await ApiAtelierRepository.getAtelier(id);
        this.atelier = atelier;
        this.dateDebut = moment(this.atelier.dateDebut).format("YYYY-MM-DD");
        this.heureDebut = moment(this.atelier.dateDebut).format("HH:mm");
        if (this.listeCampus.length === 1) {
          this.atelier.campus.id = this.listeCampus[0].id;
          this.atelier.campus.libelle = this.listeCampus[0].libelle;
        }
      } catch (error) {
        this.populateErrors(error);
      }
    },
    async enregistrer() {
      this.loadingAtelier = true;
      this.atelier.dateDebut = moment(this.dateDebut)
        .add(this.heureDebut)
        .format("YYYY-MM-DD HH:mm");
      try {
        if (this.idAtelier > 0) {
          await ApiAtelierRepository.updateAtelier(
            this.idAtelier,
            this.atelier
          );
          this.$toast.success("Atelier modifié");
        } else {
          await ApiAtelierRepository.addAtelier(this.atelier);
          this.$toast.success("Atelier ajouté");
        }
      } catch (error) {
        this.populateErrors(error);
      } finally {
        this.loadingCampus = false;
        this.$router.push({ name: "gestion-ateliers" });
      }
    },
    async getListeCampus() {
      try {
        const campusSuaio = await ApiCampusRepository.getCampusSUAIO();
        this.listeCampus = campusSuaio;
        if (this.listeCampus.length === 1) {
          this.atelier.campus.id = this.listeCampus[0].id;
          this.atelier.campus.libelle = this.listeCampus[0].libelle;
        }
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      }
    },
    async getListeAnimateurs() {
      try {
        const referents = await ApiReferentRepository.getReferentsSuaio();
        this.listeAnimateurs = referents;
      } catch (error) {
        if (error.response) {
          if (error.response.data.status !== 404) {
            this.$toast.error(error.response.data.messages[0]);
          }
        }
      }
    },
    initDateDebut() {
      if (this.idAtelier > 0) {
        return moment(this.atelier.dateDebut).format("YYYY-MM-DD");
      }
      return "";
    },
    initHeureDebut() {
      if (this.idAtelier > 0) {
        return moment(this.atelier.dateDebut).format("HH:mm");
      }
      return "";
    },
    isAtelierEchu(atelier) {
      return atelier.dateDebut
        ? moment() > moment(atelier.dateDebut)
          ? true
          : false
        : false;
    },
  },
};
</script>
